export default __webpack_public_path__ + "static/media/Boots of Heroic Soul.31ed4040.jpg";